import Vue from 'vue';
import ConversationApi from '../../api/conversations';
import { buildTimeline } from '../../routes/dashboard/conversation/ProactiveFollowUps/timeline';

// Tipos de mutación locales (el módulo es namespaced, no colisionan con otros).
const SET_UI_FLAG = 'SET_PROACTIVE_FOLLOW_UPS_UI_FLAG';
const SET_RECORDS = 'SET_PROACTIVE_FOLLOW_UPS';

const state = {
  // records[conversationId] = { pending: [], done: [], timeline: { cadence, items, legacy } }
  // `timeline` siempre existe: si el backend es viejo y no lo manda, se arma
  // con pending/done (ver buildTimeline).
  records: {},
  uiFlags: {
    isFetching: false,
    hasError: false,
  },
};

export const getters = {
  getUIFlags($state) {
    return $state.uiFlags;
  },
  getByConversation: $state => id => {
    return (
      $state.records[Number(id)] || {
        pending: [],
        done: [],
        timeline: buildTimeline(null),
        loaded: false,
      }
    );
  },
};

export const actions = {
  // Acepta el id pelado o { conversationId, silent }. `silent`: refresco en
  // segundo plano (llegó un mensaje, se mandó un comando): no prende el
  // spinner ni pisa el error visible.
  get: async ({ commit }, payloadOrId) => {
    const { conversationId, silent = false } =
      payloadOrId && typeof payloadOrId === 'object'
        ? payloadOrId
        : { conversationId: payloadOrId };
    if (!silent) commit(SET_UI_FLAG, { isFetching: true, hasError: false });
    try {
      const { data } =
        await ConversationApi.getProactiveFollowUps(conversationId);
      const body = data || {};
      commit(SET_RECORDS, {
        id: conversationId,
        data: {
          pending: body.pending || [],
          done: body.done || [],
          timeline: buildTimeline(body),
          loaded: true,
        },
      });
      commit(
        SET_UI_FLAG,
        silent ? { hasError: false } : { isFetching: false, hasError: false }
      );
    } catch (error) {
      if (!silent) commit(SET_UI_FLAG, { isFetching: false, hasError: true });
    }
  },
  cancel: async ({ dispatch }, { conversationId, pfuId }) => {
    await ConversationApi.cancelProactiveFollowUp(conversationId, pfuId);
    // Re-fetch para que el ítem pase a cancelado sin parpadear el panel.
    await dispatch('get', { conversationId, silent: true });
  },
};

export const mutations = {
  [SET_UI_FLAG]($state, data) {
    $state.uiFlags = { ...$state.uiFlags, ...data };
  },
  [SET_RECORDS]($state, { id, data }) {
    Vue.set($state.records, Number(id), data);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
